import React from "react";
import { useTranslation } from "react-i18next";

import { getDaysTexts } from "../utils";
import { Week } from "../week";
import { Props } from "./types";
import { TimeView } from "./timeView";
import styles from "./styles.scss";

function WeeklyView({
  date,
  week,
  events,
  milestones,
  unavailabilities,
  calendarsHolidays,
  tasks,
  filter,
}: Props) {
  const { t } = useTranslation();
  const daysNames = getDaysTexts(t);

  return (
    <div className={styles.weeklyView}>
      <div className={styles.labels}>
        <h3 className={styles.dayName}>{daysNames[0]}</h3>
        <h3 className={styles.dayName}>{daysNames[1]}</h3>
        <h3 className={styles.dayName}>{daysNames[2]}</h3>
        <h3 className={styles.dayName}>{daysNames[3]}</h3>
        <h3 className={styles.dayName}>{daysNames[4]}</h3>
        <h3 className={styles.dayName}>{daysNames[5]}</h3>
        <h3 className={styles.dayName}>{daysNames[6]}</h3>
      </div>
      <Week
        week={week}
        filter={filter}
        events={events}
        unavailabilities={unavailabilities}
        milestones={milestones}
        calendarsHolidays={calendarsHolidays}
        tasks={tasks}
        selectedDate={date}
      />
      <TimeView
        week={week}
        filter={filter}
        events={events}
        tasks={tasks}
        unavailabilities={unavailabilities}
      />
    </div>
  );
}

export { WeeklyView };
